import { mapActions } from 'vuex'
import {
    getFbSdk,
    fbLogin,
} from '../../helpers/fb_sdk.js'
export default {
    data() {
        return {
            loadingGoogle: false,
            loadingFacebook: false,
            loadingApple: false
        }
    },
    created() {
        if(process.env.VUE_APP_DEVICE == 'desktop') {
            new Promise(async resolve => {
                const sdk = await getFbSdk({ appId: '290980708810852', version: 'v3.2' });
                resolve();
            });
        }
    },
    mounted() {
        if (process.env.VUE_APP_DEVICE == 'desktop') {
            this.includeGoogleAPI();
            this.includeAppleAPI();
        }
    },
    methods: {
        ...mapActions('auth', [
          'doFBLogin',
          'doGoogleLogin',
          'doAppleLogin'
        ]),

        includeGoogleAPI() {
            if(document.getElementById('google-api-script')) {
                return;
            }

            let gApiScript = document.createElement('script');
            gApiScript.id = 'google-api-script';
            gApiScript.async = true;
            gApiScript.defer = true;
            gApiScript.src = 'https://apis.google.com/js/platform.js?onload=onLoadCallback';
            document.head.append(gApiScript);

            window.onLoadCallback = () => {
                this.loadGoogleAuthAPI();
            }
        },

        loadGoogleAuthAPI() {
            window.gapi.load('auth2', () => {
                new Promise(async resolve => {
                    window.gapi.auth2.init({
                        client_id: '163309041308-a7hb5sec5q46o7vr2h8e5m6g13ds13cv.apps.googleusercontent.com'
                    });
                    resolve();
                });
            });
        },

        includeAppleAPI() {
            if(document.getElementById('apple-api-script')) {
                return;
            }

            let appleApiScript = document.createElement('script');
            appleApiScript.id = 'apple-api-script';
            appleApiScript.async = true;
            appleApiScript.defer = true;
            appleApiScript.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
            appleApiScript.onload = () => {
                AppleID.auth.init({
                    clientId: 'erovinieta.untrr.auth',
                    usePopup: true,
                    redirectURI: process.env.VUE_APP_URL,
                    scope: 'name email',
                });
                this.loadingApple = true;
            };
            document.head.append(appleApiScript);

            document.addEventListener('AppleIDSignInOnSuccess', async (event) => {
                event.stopImmediatePropagation();

                // Handle successful response.
                await this.doAppleLogin(event.detail.authorization.id_token);
                this.redirectAfterLogin();
            });

            // Listen for authorization failures.
            document.addEventListener('AppleIDSignInOnFailure', (event) => {
                // Handle error.
                console.log(event.detail.error);
                event.stopImmediatePropagation();
            });
        },

        async loginApple() {
            if (process.env.VUE_APP_DEVICE == 'desktop') {   
                await AppleID.auth.signIn();
            }
            else 
            {
                await this.loginAppleOnMobileApp();
            }
        },

        async loginFacebook() {
            if(process.env.VUE_APP_DEVICE == 'desktop') {
                this.loadingFacebook = true;
                let response = await fbLogin();
                if (response.authResponse) {
                    try {
                        let login = await this.doFBLogin(response.authResponse.accessToken);
                        this.redirectAfterLogin();
                    }
                    catch(err) {
                        this.loadingFacebook = false;
    
                        if(err.response) {
                            this.$dialog.alert({
                                'message': err.response.data.error,
                                'confirmButtonText': this.$t('btn_i_understand')
                            });
                        }
                    }
                }
                else {
                    this.loadingFacebook = false;
                    console.log('User cancelled login or did not fully authorize.');
                }
            }
            else {
                this.loginFacebookOnMobileApp();
            }
        },

        async loginGoogle() {
            if (process.env.VUE_APP_DEVICE == 'desktop') {
                try {
                    this.loadingGoogle = true;
                    this.googleAuth = window.gapi.auth2.getAuthInstance();

                    let response = await this.googleAuth.signIn();
                    let authResponse = response.getAuthResponse(true);

                    if (this.googleAuth.isSignedIn.get()) {
                        let login = await this.doGoogleLogin(authResponse.access_token);
                        this.redirectAfterLogin();
                    }
                    else {
                        this.loadingGoogle = false;
                        console.log('User cancelled login or did not fully authorize.');
                    }
                }
                catch (err) {
                    this.loadingGoogle = false;

                    if (err.response) {
                        this.$dialog.alert({
                            'message': err.response.data.error,
                            'confirmButtonText': this.$t('btn_i_understand')
                        });
                    }
                }
            }
            else {
                this.loginGoogleOnMobileApp();
            }
        },

        async loginGoogleOnMobileApp() {
            window.plugins.googleplus.login(
                {
                    'scopes': 'https://www.googleapis.com/auth/drive.file profile',
                    'offline': true,
                    'webClientId': '643241197237-tsi4nb5sbbo8lou2os623kh4do8sl3rc.apps.googleusercontent.com'
                },
                async (obj) => {
                    await this.doGoogleLogin(obj.accessToken);
                    this.redirectAfterLogin();
                },
                function (msg) {
                    alert('Erro');
                    alert('error: ' + msg);
                }
            );
        },

        async loginFacebookOnMobileApp() {
            facebookConnectPlugin.login(
                ["public_profile", "email"],
                async (userData) => {
                    await this.doFBLogin(userData.authResponse.accessToken);
                    this.redirectAfterLogin();
                },
                function loginError (error) {
                    console.log(error)
                }
            );
        },

        async loginAppleOnMobileApp() {
            if(process.env.VUE_APP_DEVICE == 'ios') {
                window.cordova.plugins.SignInWithApple.signin(
                    { requestedScopes: [0,1] },
                    async (data) => {
                        await this.doAppleLogin(data.identityToken);
                        this.redirectAfterLogin();
                    },
                    function(err){
                        console.log('Error, try again later.');
                    }
                );
            }
        },

        redirectAfterLogin() {
            this.loading = false;
            this.loadingGoogle = false;
            this.loadingFacebook = false;
            this.loadingApple = false;

            if (['login', 'account-activate'].includes(this.$route.name)) {
                this.$router.push({ name: 'homepage' });
            }
            else {
                if (this.$route.params.from === undefined) {
                    //we get the vehicles of the logged in user, if he logs in from homepage
                    this.getVehicles();
                }

                if(this.$route.name != 'vignette') {
                    this.$router.push({ name: 'vignette' });
                }
            }
        }
    }
}